
import axios from 'axios';
export default {
    async AIGenerateText(context, format) {

		console.log('Generating content... format:', format);

		try{
			const serverData = await axios.get(`/api/clients/findAIServer/${context.getters.getAuthUsername}`);
			console.log('serverIP', serverData);
			const serverIP = serverData.data;
            console.log('server ip data', serverIP);
            //serverIP
			if(serverIP){
				let paramsObj = {}; // Initialize it here to avoid "undefined"
				
                if (format === 'title' || format === 'details') {
					const parentNodeId = context.getters.getCurrentNode.parent;
                    console.log('parentnodeid', parentNodeId);
                    let parentNodeData = null;
                    
					if (parentNodeId !== "root") {
                        try {
                            const parentNode = await axios.get(`/api/clients/getCurrentNode/${parentNodeId}`);
                            parentNodeData = parentNode.data;
                            console.log("Fetched parent node:", parentNodeData);
                        } catch (error) {
                            console.error("Error fetching parent node:", error);
                        }
                    } else {
                        console.log("No parent node, setting as null.");
                    }

                    console.log("parentNodeData before JSON.stringify:", parentNodeData);
					
                    paramsObj = {
					  fields: JSON.stringify(context.getters.getAIPopUpFields),
					  format: format,
                      //node: JSON.stringify(parentNodeData),
                      node: parentNodeData ? JSON.stringify(parentNodeData) : JSON.stringify(context.getters.getCurrentNode),
					  clientSlug: context.getters.getClientSlug,
					  serverIP: serverIP
					}; 
				}
				if (format === 'blog' || format === 'social') {
			
					paramsObj = {
						fields: JSON.stringify(context.getters.getAIPopUpFields),
						format: format,
						clientSlug: context.getters.getClientSlug,
						serverIP: serverIP
					}; 
			
				}

                console.log('ai params:',paramsObj);
		
                let host = window.location.host; // "localhost:8080"
                let hostname = host.split(':')[0]; // "localhost"

                //do a check to see if we are live or working locally
                const isLocal = window.location.hostname === "localhost";
                const aiBaseURL = isLocal ? `${window.location.protocol}//${window.location.hostname}:1234` : `${window.location.protocol}//${window.location.hostname}`;
                console.log("base url",  aiBaseURL);
                console.log("host url",  hostname);
                console.log('sending ai data:', [paramsObj, `${aiBaseURL}/ai/generativeAI`]);

                //let params = { param1: 'value1', param2: 'value2' };
                const response = await axios.post(`${aiBaseURL}/ai/generativeAI`, { ...paramsObj });
                const data = response.data;
                context.commit('setAIPopUpFields', {prop: 'generatedContent', val: data});
				console.log('AI RESPONSED DATA:', data);
                console.log('getauthusername', JSON.stringify(context.getters.getAuthUsername));
                const res = await axios.get(`/api/clients/removeAIServer/${context.getters.getAuthUsername}`);
                console.log('removed server:', res.data);
			}else{
				alert('Sorry, AI slots are currently all being used. Please try again later.');
			}
		}catch(error){
			console.log('AIGenerateText catch error', error);
            try {
                const res = await axios.get(`/api/clients/removeAIServer/${context.getters.getAuthUsername}`);
                console.log('removed server:', res.data);
                alert('Sorry, there has been a problem. Please try again later.');
                context.commit('setAIPopUpFields', {prop: 'generatedContent', val: 'Unable to get response'});
            } catch (error) {
                console.log('Error removing server:', error);
            }
		}
	},
    approveAIGeneratedContent(context, payload){
        const status = payload.status
        const format = payload.format
        if(status){
            const data = context.getters.getAIPopUpFields.generatedContent;
            console.log('the approved data:', data);
            
            if(format === 'social'){
                context.commit('setSocial', {prop: 'post/caption', val: data});
            }
            if(format === 'blog'){
                context.commit('setAIPopUpFields', {prop: 'response', val: data})
            }
            if(format === 'title'){
                context.commit("updateNodeFieldValue", {fieldGroup : 'title', field: 'title', value : data})
            }
            if(format === 'details'){
                context.commit("updateNodeFieldValue", {fieldGroup : 'details', field: 'details', value : data})
            }
        }else{
            context.commit('setAIPopUpFields', {prop: 'generatedContent', val: ''});
            console.log('user has denied')
        }
    }
}